import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { Card, Container, LayoutVertical, Typography } from "@/components";
import { FetchContext as context } from "@/contexts/FetchContext";
import getPortalType from "@/utils/getPortalType";
import { NotificationList, useNotifications } from "@/features/common/Notifications";
import { path } from "@/path";

export const Notifications = () => {
  const { state } = useContext(context);
  const { notifications } = useNotifications();
  const { t } = useTranslation();
  const portalType = getPortalType();

  return (
    <Container isLoading={state.loading}>
      <Helmet title={t("NOTIFICATION")} />

      <LayoutVertical>
        <Typography variant="h1">{t("NOTIFICATION")}</Typography>
        <Card>
          <NotificationList
            notices={notifications}
            detailUrl={portalType === "crew" ? path.crew.Notifications.detail : path.driver.Notifications.detail}
          />
        </Card>
      </LayoutVertical>
    </Container>
  );
};
